module.exports = __webpack_public_path__ + "img/a183fa4.svg";